import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported, logEvent } from "firebase/analytics";

// Welivin Customer Panel Firebase configuration
export const customerPanelFirebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyAQ1JsBnfn-7nfm6_2j_MegnITbPbT41uM",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "welivin-customer-panel.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "welivin-customer-panel",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "welivin-customer-panel.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "299611060532",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:299611060532:web:08b9c442bd5aeacc958d61",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-NFSDMT1TKC"
};

// Welivin Website Firebase configuration (available for website / reference)
export const websiteFirebaseConfig = {
  apiKey: "AIzaSyAnQJPljXRclZqW-lsCUHgOuJrJtlbejLI",
  authDomain: "welivin-website.firebaseapp.com",
  projectId: "welivin-website",
  storageBucket: "welivin-website.firebasestorage.app",
  messagingSenderId: "76557098762",
  appId: "1:76557098762:web:dbde75b6ec7df4d543a4f3",
  measurementId: "G-WD5KVR6T2K"
};

// Default config for Welivin Customer Panel
const firebaseConfig = customerPanelFirebaseConfig;

// Initialize Firebase App
export const app = initializeApp(firebaseConfig);

// Initialize Firebase Analytics safely (with environment & browser support check)
export let analytics = null;
let analyticsPromise = null;

export const getAnalyticsInstance = () => {
  if (typeof window === "undefined") {
    return Promise.resolve(null);
  }
  if (analytics) {
    return Promise.resolve(analytics);
  }
  if (!analyticsPromise) {
    analyticsPromise = isSupported()
      .then((supported) => {
        if (supported) {
          analytics = getAnalytics(app);
          return analytics;
        }
        return null;
      })
      .catch((err) => {
        console.warn("Firebase Analytics is not supported in this environment:", err);
        return null;
      });
  }
  return analyticsPromise;
};

// Initialize immediately in supported browser environments
if (typeof window !== "undefined") {
  getAnalyticsInstance();
}

/**
 * Log a page view event to Firebase Analytics
 * @param {string} path - The page path (e.g., /dashboard)
 * @param {string} title - The document or route title
 */
export const trackPageView = async (path, title) => {
  try {
    const instance = await getAnalyticsInstance();
    if (instance) {
      logEvent(instance, "page_view", {
        page_path: path || window.location.pathname,
        page_title: title || document.title,
        page_location: window.location.href
      });
    }
  } catch (error) {
    console.warn("Firebase trackPageView error:", error);
  }
};

/**
 * Log a custom event to Firebase Analytics
 * @param {string} eventName - The name of the event
 * @param {object} eventParams - Optional parameters
 */
export const logCustomEvent = async (eventName, eventParams = {}) => {
  try {
    const instance = await getAnalyticsInstance();
    if (instance) {
      logEvent(instance, eventName, eventParams);
    }
  } catch (error) {
    console.warn(`Firebase logEvent (${eventName}) error:`, error);
  }
};

export default app;
